import { useEffect, useState } from 'react';

export const useDebounced = <T>(value: T, delayMs: number) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => {
      clearTimeout(timer);
    };
  }, [value]);

  return debouncedValue;
};
